// extracted by mini-css-extract-plugin
export default {"NewBox":"NewBox_NewBox__fgJJr","row":"NewBox_row__geVLg","description":"NewBox_description__zVa76","title":"NewBox_title__b+jgC","icon":"NewBox_icon__091+1"};